import { motion } from "framer-motion";
import { BIO_PARAGRAPHS } from "@/lib/data";

export default function Bio() {
    return (
        <section
            id="bio"
            data-testid="bio-section"
            className="bg-[#F7F5F0] py-24 md:py-32"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid grid-cols-12 gap-6 md:gap-12">
                    <div className="col-span-12 md:col-span-3">
                        <motion.div
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.7 }}
                        >
                            <p className="eyebrow">§ 01</p>
                            <h2 className="font-serif-display text-3xl md:text-4xl mt-4 leading-[0.95] text-[#1A1A1A]">
                                The
                                <br />
                                <span className="italic">TL;DR</span>
                            </h2>
                        </motion.div>
                    </div>

                    <div className="col-span-12 md:col-span-9">
                        <div className="space-y-8 max-w-3xl border-l border-[#D1CFC9] pl-8 md:pl-12">
                            {BIO_PARAGRAPHS.map((p, idx) => (
                                <motion.p
                                    key={idx}
                                    initial={{ opacity: 0, y: 18 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true, amount: 0.4 }}
                                    transition={{
                                        duration: 0.7,
                                        delay: idx * 0.08,
                                    }}
                                    data-testid={`bio-paragraph-${idx}`}
                                    className={
                                        idx === BIO_PARAGRAPHS.length - 1
                                            ? "font-serif-display italic text-2xl md:text-3xl text-[#1A1A1A] leading-snug"
                                            : "text-base md:text-lg text-[#1A1A1A] leading-relaxed font-light"
                                    }
                                >
                                    {p}
                                </motion.p>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
